/**
 * Created by emanuele on 23/05/2017.
 */
import React, {Component}  from 'react';
import PrintButton from '../PrintButton'
import PdfButton from '../PdfButton'
import ReportCommesseView from '../report/ReportCommesseView'
import CommesseElenco from '../../pdf/CommesseElenco';

class CommesseReportList extends Component {

    constructor(props) {
        super(props);
        this.pdfExport = this.pdfExport.bind(this);
    }

    pdfExport(){
        let ce = new CommesseElenco();
        ce.setTitle("Report Commesse");
        ce.setFileName("report-commesse.pdf");
        ce.setFilterDescription(this.props.filterDescription);
        ce.createPdf(this.props.items);
    }

    render(){
        return (
            <div className="ui segments">
                <div className="ui secondary segment no-print">
                    <div className="ui three column stackable grid">
                        <div className="row">
                            <div className="column">
                                <PrintButton />
                                <PdfButton onClick={(ev) => (this.pdfExport())} />
                            </div>
                            <div className="column">
                            </div>
                            <div className="column">
                            </div>
                        </div>
                    </div>
                </div>
                <div id="printme" className="ui segment">
                    <ReportCommesseView {...this.props} />
                </div>
            </div>
        )
    }
}

export default CommesseReportList;


/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommesseReportList.js
 **/